import Util from '@/assets/libs/util'
import CartController from '@/assets/controllers/CartController'

const buildSaleData = (paymentNumber, nitNumber, paymentMethod, cart, eventData, paymentType = 'credit') => {
  const orderData = {}
  const dataObject = {
    paymentType,
    taaSaleId: '',
    order: orderData,
    eventName: eventData.name,
    eventId: eventData.code,
    eventExpiration: eventData.endDate
  }

  orderData.orderId = null
  orderData.closeByApi = true
  orderData.pagerId = ''
  orderData.items = []

  const consumerData = Util.getLocalVar('storedUser')
  orderData.clientCode = consumerData.clientCode
  orderData.consumerCode = consumerData.consumerCode
  orderData.consumerId = consumerData.consumerId

  orderData.orderDescription = {}
  orderData.orderDescription.toTravel = false
  orderData.orderDescription.driveThru = false
  orderData.orderDescription.orderType = 'TAA'
  orderData.orderDescription.preOrderDate = ''
  const totalPrice = CartController.calculateTotalPrice(false, false)

  orderData.orderDescription.productsValue = totalPrice
  orderData.orderDescription.deliveryFee = 0
  orderData.orderDescription.totalValue = orderData.orderDescription.productsValue + orderData.orderDescription.deliveryFee
  orderData.orderDescription.changeValue = 0
  orderData.orderDescription.serviceTax = 0
  orderData.orderDescription.giftCards = []
  orderData.orderDescription.deliveryAddress = null
  orderData.orderDescription.isScheduled = false
  orderData.orderDescription.scheduledDate = ''
  orderData.orderDescription.orderCPF = consumerData?.consumer?.cpf?.replace(/\D/g, '') || null

  orderData.orderDescription.payments = [{
    paymentCode: paymentMethod,
    paymentName: '',
    value: totalPrice,
    nsu: paymentNumber,
    nit: nitNumber,
    digitalWallet: null
  }]

  orderData.orderDescription.payments[0].clientCode = consumerData.clientCode
  orderData.orderDescription.payments[0].consumerCode = consumerData.consumerCode

  // Monta os itens da venda, de acordo com o Carrinho
  cart.forEach(product => {
    const current = {}
    current.productName = product.productName
    current.productCode = product.productCode
    current.productPrint = product.productPrint
    current.quantity = product.quantity || 1
    current.unitValue = product.price
    current.discount = 0
    current.toTravel = false
    current.note = product.typedObs || ''
    current.observations = []
    current.childItems = []

    // Trata as observacoes para este produto (produto pai ou item simples)
    product.observations.forEach(observation => {
      if (observation.quantity === undefined) {
        observation.quantity = 1
      }
      current.observations.push(observation)
    })

    // Trata os itens filhos deste produto (quando for combo)
    product.productCombo.forEach(childItem => {
      const newChild = {
        productCode: childItem.subItemCode,
        productName: childItem.subItemName,
        productPrint: childItem.subItemProductPrint,
        groupPrint: childItem.groupPrint,
        unitValue: childItem.price,
        toTravel: false,
        quantity: 1,
        discount: 0,
        note: childItem.typedObs || '',
        observations: []
      }

      // Trata as observacoes dos itens filhos (quando for combo)
      if (childItem && childItem.observations) {
        childItem.observations.forEach(obs => {
          const newObs = {
            obsGroupCode: obs.subItemObsGroupCode,
            obsCode: obs.subItemObsCode,
            obsName: obs.subItemObsName,
            price: obs.price || 0,
            quantity: obs.quantity || 1,
            obsType: obs.subItemObsType,
            obsProductCode: obs.subItemObsProductCode
          }
          newChild.observations.push(newObs)
        })
      }

      // Trata os itens filhos de filhos quando for combo do combo
      if (childItem.choosen) {
        newChild.childItems = []
        const keys = Object.keys(childItem.choosen)
        keys.forEach(key => {
          childItem.choosen[key].forEach(subSubProd => {
            const newInnerChild = {
              productCode: subSubProd.subItemCode,
              productName: subSubProd.subItemName,
              productPrint: subSubProd.groupPrint,
              unitValue: subSubProd.price,
              toTravel: false,
              quantity: 1,
              discount: 0,
              note: subSubProd.typedObs || '',
              observations: []
            }

            // Trata as observacoes dos itens filhos de filhos (quando for combo do combo)
            if (subSubProd && subSubProd.observations) {
              subSubProd.observations.forEach(obs => {
                const newObs = {
                  obsGroupCode: obs.subItemObsGroupCode,
                  obsCode: obs.subItemObsCode,
                  obsName: obs.subItemObsName,
                  price: obs.price || 0,
                  quantity: obs.quantity || 1,
                  obsType: obs.subItemObsType,
                  obsProductCode: obs.subItemObsProductCode
                }
                newInnerChild.observations.push(newObs)
              })
            }
            const subQuantity = subSubProd.quantity ? subSubProd.quantity : 1
            for (let i = 0; i < subQuantity; i++) {
              newChild.childItems.push(newInnerChild)
            }
          })
        })
      }
      const quantity = childItem.quantity ? childItem.quantity : 1
      for (let i = 0; i < quantity; i++) {
        current.childItems.push(newChild)
      }
    })

    const fatherQuantity = product.quantity ? product.quantity : 1
    for (let i = 0; i < fatherQuantity; i++) {
      current.quantity = 1
      orderData.items.push(current)
    }
  })
  return dataObject
}

export default {
  buildSaleData
}
